import Vue from 'vue';
import Vuex from 'vuex';
import accounts from './modules/accounts';
import activity from './modules/activity';
import adverts from './modules/adverts';
import banks from './modules/banks';
import bbbProductTerms from './modules/bbbProductTerms';
import bills from './modules/bills';
import brokers from './modules/brokers';
import businessTypes from './modules/businessTypes';
import categories from './modules/categories';
import contents from './modules/contents';
import customer from './modules/customer';
import dashboards from './modules/dashboards';
import dialler from './modules/dialler';
import enquiries from './modules/enquiries';
import enquiryStatus from './modules/enquiryStatus';
import feeTiers from './modules/feeTiers';
import funders from './modules/funders';
import groups from './modules/groups';
import http from './modules/http';
import imports from './modules/imports';
import journeys from './modules/journeys';
import journeyTypes from './modules/journeyTypes';
import notifications from './modules/notifications';
import owners from './modules/owners';
import partners from './modules/partners';
import platforms from './modules/platforms';
import products from './modules/products';
import productTypes from './modules/productTypes';
import productSuitabilities from './modules/productSuitabilities';
import providers from './modules/providers';
import questions from './modules/questions';
import referrals from './modules/referrals';
import registration from './modules/registration';
import route from './modules/route';
import twilio from './modules/twilio';
import ui from './modules/ui';
import user from './modules/user';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    accounts,
    activity,
    adverts,
    banks,
    bbbProductTerms,
    bills,
    brokers,
    businessTypes,
    categories,
    contents,
    customer,
    dashboards,
    dialler,
    enquiries,
    enquiryStatus,
    feeTiers,
    funders,
    groups,
    http,
    imports,
    journeys,
    journeyTypes,
    notifications,
    owners,
    partners,
    platforms,
    products,
    productSuitabilities,
    productTypes,
    providers,
    questions,
    referrals,
    registration,
    route,
    twilio,
    ui,
    user
  },
  strict: debug
});
